/* eslint-disable no-undef, camelcase */
import { Globals } from '@bwoty-web/ui-kit';
import { hydrateRoot } from 'react-dom/client';
import TilesView from '../shared/views/tiles/tilesView';

const initialStateTiles = window.__INITIAL_STATE_TILES__;
/*
  Allow lazy load of components.
  Sets webpack publicPath for files during runtime, since the publicPath is different for each environment.
  Filepaths cannot be relative since the script is run on other domains.
*/
__webpack_public_path__ = `${initialStateTiles?.baseUrl}/static/`;

delete window.__INITIAL_STATE_TILES__;
const tilesRoot = document.getElementById('tiles-view');

if (tilesRoot) {
  hydrateRoot(
    tilesRoot,
    <Globals
      legacyMode={initialStateTiles.legacyMode}
      siteId={initialStateTiles.siteId}
    >
      <TilesView
        activeTileId={initialStateTiles.activeTileId}
        baseUrl={initialStateTiles.baseUrl}
        imageDomain={initialStateTiles.imageDomain}
        initialIsMobile={initialStateTiles.initialIsMobile}
        itemContent={initialStateTiles.itemContent}
        itemType={initialStateTiles.itemType}
        siteId={initialStateTiles.siteId}
        tiles={initialStateTiles.tiles?.pushList}
        wvId={initialStateTiles.wvId}
      />
    </Globals>,
  );
}
